/**
 * Created by vladislav on 29.10.2021
 */

const Shortcuts = function () { 
    Shortcuts.List.filter((item) => item.action).forEach((item) => {
        const combo = item.keys.map((key) => InputDispatcher.KEY[key]);

        cleverapps.inputDispatcher.onKeyCombo(combo, cleverapps.accumulate(0, item.action));
    });
};

Shortcuts.GetMemo = function () {
    const memo = {};

    Shortcuts.List.forEach((item) => {
        if (!item.filter()) {
            return;
        }

        const key = item.keys.map((key) => key.toUpperCase()).join("+");
        memo[`${item.name} - ${key}`] = item.action || function () {};
    }, this);

    return memo;
};

Shortcuts.selectedNodeFilter = function () {
    return cleverapps.sceneDebugger.selectedNode !== undefined;
};
Shortcuts.noSelectedNodeFilter = function () {
    return cleverapps.sceneDebugger.selectedNode === undefined;
};
Shortcuts.Map2dFilter = function () {
    return typeof Map2d !== "undefined" && Map2d.currentMap !== undefined && cleverapps.sceneDebugger.selectedNode === undefined;
};
Shortcuts.editorMap2dFilter = function () {
    return Shortcuts.Map2dFilter() && cleverapps.config.editorMode;
};
Shortcuts.ttfFilter = function () {
    return cleverapps.sceneDebugger.selectedNode instanceof cc.LabelTTF;
};

Shortcuts.List = [
    {
        name: "drawCalls",
        keys: ["ctrl", "q"],
        action: function () {
            cleverapps.drawCallsDebugger.debugDrawCalls();
        },
        filter: Shortcuts.noSelectedNodeFilter
    },
    {
        name: "toggleTexts",
        keys: ["ctrl", "y"],
        action: function () {
            cleverapps.sceneDebugger.toggleTexts();
        },
        filter: Shortcuts.noSelectedNodeFilter
    },
    {
        name: "makeSnapshot",
        keys: ["alt", "s"],
        action: function () {
            cleverapps.snapshots.createSnapshot();
        },
        filter: Shortcuts.noSelectedNodeFilter
    },
    {
        name: "toggleTimeScale",
        keys: ["space"],
        action: function () {
            if (cleverapps.debugSlider.isActive()) {
                cleverapps.timeScaleManager.setValue(1);
                cleverapps.debugSlider.remove();
            } else if (!cleverapps.config.editorMode) {
                cleverapps.timeScaleManager.setValue(0);
                cleverapps.debugSlider.createTimeScaleSlider();
            }
        },
        filter: Shortcuts.noSelectedNodeFilter
    },
    {
        name: "incrementTimeScale",
        keys: ["shift", "."],
        action: function () {
            cleverapps.timeScaleManager.add(TimeScaleManager.MIN_STEP);
            console.log(`Current timescale ${cleverapps.timeScaleManager.value}`);
        },
        filter: Shortcuts.noSelectedNodeFilter
    },
    {
        name: "decrementTimeScale",
        keys: ["shift", ","],
        action: function () {
            cleverapps.timeScaleManager.add(-TimeScaleManager.MIN_STEP);
            console.log(`Current timescale ${cleverapps.timeScaleManager.value}`);
        },
        filter: Shortcuts.noSelectedNodeFilter
    },
    {
        name: "selectNode",
        keys: ["ctrl", "l🖱"],
        filter: Shortcuts.noSelectedNodeFilter
    },
    {
        name: "deleteNode",
        keys: ["Delete"],
        filter: Shortcuts.selectedNodeFilter
    },
    {
        name: "showMap2dReference",
        keys: ["alt", "v"],
        filter: function () {
            return typeof Editor !== "undefined" && Editor.currentEditor && Editor.currentEditor.map.reference && Editor.currentEditor.map.reference.isAvailable();
        },
        action: function () {
            const reference = Editor.currentEditor.map.reference;
            reference.setImageVisible(!reference.isImageVisible());
        }
    },
    {
        name: "toggleVisible",
        keys: ["v"],
        action: function () {
            cleverapps.sceneDebugger.toggleMatchedNodes();
        },
        filter: Shortcuts.selectedNodeFilter
    },
    {
        name: "moveNode [10px]",
        keys: ["✥[+shift]"],
        filter: Shortcuts.selectedNodeFilter
    },
    {
        name: "scale",
        keys: ["s", "✥"],
        filter: Shortcuts.selectedNodeFilter
    },
    {
        name: "mirror",
        keys: ["m", "✥"],
        filter: Shortcuts.selectedNodeFilter
    },
    {
        name: "rotate",
        keys: ["r", "✥"],
        filter: Shortcuts.selectedNodeFilter
    },
    {
        name: "changeWidth",
        keys: ["w", "⇅"],
        filter: Shortcuts.selectedNodeFilter
    },
    {
        name: "changeHeight",
        keys: ["h", "⇅"],
        filter: Shortcuts.selectedNodeFilter
    },
    {
        name: "changeFontSize",
        keys: ["f", "✥"],
        filter: Shortcuts.ttfFilter
    },
    {
        name: "changeTTFDimensions",
        keys: ["d", "✥"],
        filter: Shortcuts.ttfFilter
    },
    {
        name: "copyUnit",
        keys: ["c", "l🖱"],
        filter: Shortcuts.Map2dFilter
    },
    {
        name: "deleteUnit [all]",
        keys: ["r🖱[+shift]"],
        filter: Shortcuts.Map2dFilter
    },
    {
        name: "demoUnit",
        keys: ["x", "l🖱"],
        filter: Shortcuts.Map2dFilter
    },

    {
        name: "showMap2dLevels",
        keys: ["l"],
        filter: function () {
            return Shortcuts.Map2dFilter();
        },
        action: function () {
            if (Shortcuts.Map2dFilter()) {
                Map2d.setTileLevelsVisible(!Map2d.tileLevelsVisible);
            }
        }
    },
    {
        name: "toggleUnits",
        keys: ["u"],
        filter: Shortcuts.Map2dFilter,
        action: function () {
            if (Shortcuts.Map2dFilter()) {
                Map2d.setUnitsVisible(!Map2d.unitsVisible);
            }
        }
    },
    {
        name: "toggleChessLayer",
        keys: ["i"],
        filter: function () {
            return Shortcuts.Map2dFilter() && Map2d.setChessLayerVisible;
        },
        action: function () {
            if (Shortcuts.Map2dFilter() && Map2d.setChessLayerVisible) {
                Map2d.setChessLayerVisible(!Map2d.chessLayerVisible);
            }
        }
    },
    {
        name: "toggleBlockedCells",
        keys: ["o"],
        filter: function () {
            return Shortcuts.Map2dFilter() && Map2d.setImpassableCellsVisible;
        },
        action: function () {
            if (Shortcuts.Map2dFilter() && Map2d.setImpassableCellsVisible) {
                Map2d.setImpassableCellsVisible(!Map2d.impassableCellsVisible);
            }
        }
    },
    {
        name: "toggleUnitLock",
        keys: ["l🖱"],
        filter: Shortcuts.Map2dFilter
    },
    {
        name: "selectAllUnits",
        keys: ["ctrl", "a"],
        filter: Shortcuts.editorMap2dFilter,
        action: function () {
            cleverapps.config.editorMode && Map2d.currentMap.selection.selectAllUnits();
        }
    },
    {
        name: "deleteSelectedUnits",
        keys: ["ctrl", "x"],
        filter: Shortcuts.editorMap2dFilter,
        action: function () {
            if (cleverapps.config.editorMode) {
                cleverapps.clipboardService.copy();
                Map2d.currentMap.selection.getSelectedUnits().forEach((selectedUnit) => {
                    Editor.currentEditor.doCommand("deleteUnit", {
                        x: selectedUnit.x, y: selectedUnit.y, hash: selectedUnit.getUnitHash()
                    });
                });
                Map2d.currentMap.selection.clearSelection();
            }
        }
    },
    {
        name: "toggleAnchorsMode",
        keys: ["a"],
        filter: Shortcuts.Map2dFilter,
        action: function () {
            if (Shortcuts.Map2dFilter()) {
                cleverapps.flags.toggle("keyboardAnchorsMode");
                cleverapps.notification.create(`Edit anchors mode ${cleverapps.flags.keyboardAnchorsMode ? "activated" : "switched off"}`);
            }
        }
    }
];
